export function expand(){

	this.currentWidth = this.currentWidth + this.widthMovement;

	if(this.currentWidth >= this.maxWidth ){
       
		this.currentWidth = this.maxWidth

        $(".smetio-app-ui-side-menu-expand-properties_"+this.id).attr("disabled", true);

        $(".smetio-app-ui-side-menu-shrink-properties_"+this.id).attr("disabled", false);

	}else if( this.currentWidth <= this.minWidth ){

		$(".smetio-app-ui-side-menu-expand-properties_"+this.id).attr("disabled", false);

	};

	$(".smetio-app-ui-side-menu-shrink-properties_"+this.id).attr("disabled", false);


    $("#"+this.id).css("width", this.currentWidth+"%");

    $(".smetio-app-ui-side-menu-show-properties_"+this.id).attr("data-smetio-show", "no");
    $(".smetio-app-ui-side-menu-hide-properties_"+this.id).attr("data-smetio-show", "yes");


};